import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import { ClientUrlFactory } from '../../ui-toolkit/rest/ClientUrlFactory';

export const urlGenerator = ClientUrlFactory(baseUrlService.WebsiteLocation);
